import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import authReducer from "./AuthSlice";
import BankReducer from "./BankSlice";
import CustomerReducer from "./CustomerSlice";
import ProductReducer from "./ProductSlice";
import InvoiceReducer from "./InvoiceSlice";
import employeeReducer from "./EmployeeSlice";
import calendarReducer from "./CalendarSlice";
import TdsReducer from "./TdsSlice";
import departmentReducer from "./DepartmentSlice";
import designationReducer from "./DesignationSlice";
import UserReducer from "./UserSlice";
import CandidateReducer from "./CandidateSlice";
import ProfileImageReducer from "./ProfileImageSlice";
import companyReducer from "./companySlice";
import branchReducer from "./BranchSlice";
import companyStatsReducer from "./companyStatsSlice";
import employeeStatsReducer from "./employeeStatsSlice";

// ✅ Combine reducers
const appReducer = combineReducers({
  auth: authReducer,
  customers: CustomerReducer,
  banks: BankReducer,
  products: ProductReducer,
  invoices: InvoiceReducer,
  employees: employeeReducer,
  calendar: calendarReducer,
  tds: TdsReducer,
  departments: departmentReducer,
  designations: designationReducer,
  users: UserReducer,
  candidates: CandidateReducer,
  profile: ProfileImageReducer,
  company: companyReducer,
  branches: branchReducer,
  companyStats: companyStatsReducer,
  employeeStats: employeeStatsReducer,
});

// ✅ Root reducer with RESET on logout
const rootReducer = (state, action) => {
  if (action.type === "auth/logout") {
    // clear all persisted state
    storage.removeItem("persist:root");
    state = undefined;
  }
  return appReducer(state, action);
};

// ✅ Persist Config
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"], // only persist these slices
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// ✅ Store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
export default store;
